import { IThemeConfig } from '../../core/theme/types';

export default {
  pictureInPictureSvgFill: {
    fill: (data: IThemeConfig) => data.color,
  },
};
